// extracted by mini-css-extract-plugin
module.exports = {"form_body":"ShipmentForm_form_body__LmA6F","trunkrs_api_input":"ShipmentForm_trunkrs_api_input__2kml4"};